/**
 * Entity Association Types
 *
 * Defines the types of relationships/associations between entities in the system.
 * Each association type may have specific rules about which entity types can be linked.
 */
export enum EntityAssociationType {
  /**
   * AP Invoice Matching
   *
   * Used for matching invoice line items to purchase order line items or sales order charges
   * during reconciliation.
   *
   * Allowed entity type pairs:
   * - AP_INVOICE → INTERNAL_PURCHASE_ORDER (header-level link)
   * - AP_INVOICE → AR_SALES_ORDER (header-level link for SO charges)
   * - AP_INVOICE → SCM_SHIPMENT (header-level link for shipment charges)
   * - AP_INVOICE_LINE_ITEM → INTERNAL_PURCHASE_ORDER_LINE_ITEM (line-level match)
   * - AP_INVOICE_LINE_ITEM → CHARGE (match to PO, SO, or Shipment charges)
   */
  AP_INVOICE_MATCHING = "AP_INVOICE_MATCHING",

  /**
   * Activity Graph
   *
   * Used for linking entities that are related in the context of activity tracking.
   * Creates a graph of related entities that should appear together in activity logs.
   *
   * Allowed entity type pairs:
   * - AR_STAGED_SALES_ORDER → INBOUND_EMAIL (source email for staged order)
   * - AR_STAGED_SALES_ORDER → AR_SALES_ORDER (created sales order)
   * - AR_STAGED_SALES_ORDER → AR_CUSTOMER (associated customer)
   * - AR_SALES_ORDER → INBOUND_EMAIL
   * - AR_SALES_ORDER → AR_CUSTOMER
   * - AP_INVOICE → INBOUND_EMAIL
   * - AP_INVOICE → AP_SUPPLIER
   */
  ACTIVITY_GRAPH = "ACTIVITY_GRAPH",
}
